<div class="padding flex column">
	<b class="bold margin-bottom-small">Choose colors and sizes</b>
	<div class="flex column gap scrollable">
		@for (color of groupedWarehouseArticles; track color.color.id) {
			<div class="flex border margin-right-small">
				@if (!data.singleColorSelection) {
					<div class="flex column justify-center padding-small center">
						<i class="primary-dark hover  hover fa {{ color.color.selected ? 'fa-solid fa-check-square' : 'fa-regular fa-square' }}" (click)="toggleColor(color)"></i>
					</div>
				}

				<div class="flex center padding-smallest padding-left-small padding-right-small bold  fix-width {{ !color.color.selected ? 'disabled' : 'hover' }} " (click)="toggleColor(color)">{{ color.color.name }}</div>
				<div class="flex flex-1 grid {{ !color.color.selected ? 'disabled' : '' }}">
					@for (size of color.sizesAndQuantity; track size.size.id) {
						<div class="flex column justify-center center padding-small {{ size.selected ? 'bg-green white' : '' }} {{ size.availableQty == 0 ? 'disabled' : 'hover' }}" (click)="size.availableQty > 0 ? selectSize(color.color, size) : null">
							<div class="flex center justify-center">
								<h4>{{ size.size.name }}</h4>
								@if (size.selected) {
									<i class="fa-solid fa-check margin-left-smallest"></i>
								}
							</div>
							<div class="flex {{ size.selected ? 'bg-white primary' : 'bg-primary white' }} {{ size.availableQty > 0 ? '' : 'red' }} radius padding-right-smallest padding-left-small ">Stock: {{ size.availableQty }}</div>
						</div>
					} @empty {
						<div class="flex center flex-1 grey bg-light-grey padding-small">No sizes available</div>
					}
				</div>
			</div>
		}
	</div>

	<div class="flex column end margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked margin-right-small">
				<i class="fa-solid fa-undo"></i>
				Discard
			</button>

			<button (click)="apply()" [disabled]="disableApply()">
				<i class="fa-solid fa-check"></i>
				Apply
			</button>
		</div>
	</div>
</div>
